import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

function ContragentsList() {
  const [contragents, setContragents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const { authFetch } = useAuth();

  useEffect(() => {
    let isMounted = true;
    async function fetchContragents() {
      try {
        setIsLoading(true);
        setErrorMessage('');
        const response = await authFetch('/api/v1/contragents', {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          }
        });
        if (!response.ok) {
          throw new Error(`Failed to load contragents: ${response.status}`);
        }
        const data = await response.json();
        if (isMounted) {
          setContragents(Array.isArray(data) ? data : (data.items || []));
        }
      } catch (error) {
        if (isMounted) setErrorMessage(error.message || 'Failed to load contragents');
      } finally {
        if (isMounted) setIsLoading(false);
      }
    }
    fetchContragents();
    return () => { isMounted = false; };
  }, []);

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Список обучающихся</h2>
      </div>

      {isLoading && (
        <div className="text-muted">Loading...</div>
      )}
      {!isLoading && errorMessage && (
        <div className="alert alert-danger" role="alert">{errorMessage}</div>
      )}
      {!isLoading && !errorMessage && (
        contragents.length === 0 ? (
          <div className="alert alert-info" role="alert">No contragents found.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">ФИО</th>
                  <th scope="col">Email</th>
                  <th scope="col">Номер телефона</th>
                </tr>
              </thead>
              <tbody>
                {contragents.map((c, index) => (
                  <tr key={c.id || c.email || index}>
                    <td>{c.name || '-'}</td>
                    <td>{c.email || '-'}</td>
                    <td>{c.phone || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}

export default ContragentsList;


